<template>
  <div class="problem-body">
    <div class="nb">
      <div class="problem-lside">
        <ul>
          <li>
            <a href="javascript:void(0);" class="nli">个人中心<b class="arrow"></b></a>
            <ul class="ulson" style="display: block;">
              <li><a href="/page.html#/pages/plateform/personalCenter">订单管理</a></li>
              <li><a href="/pageLR.html#/pages/plateform/cart">购物车</a></li>
              <li><a href="/page.html#/pages/plateform/address">收货地址</a></li>
              <li><a href="/page.html#/pages/plateform/personalInfo">个人信息</a></li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="problem-rside">
        <div class="probar">
          <a href="#">个人中心-收货地址</a>
        </div>

        <div class="sh-address">
          <ul>
            <li class="add-add">
              <div class="add-box add-box-center" @click="openDialog">
                <a href="javascript:void(0);">
                  <i class="icon-add-add"></i>
                  {{ $t('address.addNewAddress') }}
                </a>
              </div>
            </li>
            <li class="default-add" v-for="(addr, index) in userAddresses" :key="index">
              <div class="inner-infos">
                <div class="addr-hd"><span>{{addr.areaName}}（{{addr.username}}）</span></div>
                <div class="addr-bd"><span></span><span>{{addr.address}}{{addr.tel}}</span></div>
                <a title="删除" style="color: brown;" @click="deleteAddress(addr)">{{ $t('address.delete') }}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <address-dialog 
      ref="addressDialog"
      :provs="provs"
      :citys="citys"
      :areas="areas"
      @refresh="listAddresses"
    />
  </div>
</template>

<script>
import AddressDialog from '@/components/plateform/address/AddressDialog'
import { listUserAddresses, deleteUserAddress, listAreas } from '@/api/plateform/addressApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'Address',
  components: {
    AddressDialog
  },
  data() {
    return {
      userAddresses: [],
      provs: [],
      citys: [],
      areas: [],
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this.listAddresses()
    this.selectArea('101', '0')
  },
  methods: {
    openDialog() {
      this.$refs.addressDialog.open()
    },
    async listAddresses() {
      try {
        const res = await listUserAddresses({
          page: 1,
          row: 100,
          userId: this.$store.getters.userId
        })
        this.userAddresses = res.data
      } catch (error) {
        console.error('获取地址列表失败:', error)
      }
    },
    async selectArea(areaLevel, parentAreaCode) {
      try {
        const res = await listAreas({
          areaLevel,
          parentAreaCode
        })
        if (areaLevel === '101') {
          this.provs = res.data
        } else if (areaLevel === '202') {
          this.citys = res.data
        } else {
          this.areas = res.data
        }
      } catch (error) {
        console.error('获取地区数据失败:', error)
      }
    },
    async deleteAddress(addr) {
      try {
        await deleteUserAddress(addr)
        this.$message.success(this.$t('address.deleteSuccess'))
        this.listAddresses()
      } catch (error) {
        console.error('删除地址失败:', error)
      }
    }
  }
}
</script>

<style scoped>
/* 保留原有样式 */
.problem-body {
  width: 100%;
}
.nb {
  display: flex;
}
.problem-lside {
  width: 200px;
}
.problem-rside {
  flex: 1;
}
.sh-address ul {
  display: flex;
  flex-wrap: wrap;
}
.sh-address li {
  width: 30%;
  margin: 10px;
}
.add-box {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ddd;
  cursor: pointer;
}
.default-add {
  border: 1px solid #ddd;
  padding: 10px;
}
</style>